import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import "../../styles/Pages//productbulkupload.css"
import CustomUpload from "../../components/Common/Uploadfile"
import { Form, message, Spin } from "antd"
import { Product } from "../../Apis/productApis"
import Table from "../../components/Common/Table"
import { BulkUploadActions } from "../../utils/TableData/PrevUploadProductFile/BulkUploadActions"
import { BulkUploadColumns } from "../../utils/TableData/PrevUploadProductFile/BulkUploadColumns"
import DeleteConfirmationModal from "../../components/Common/Modals/DeleteConfirmationModal"
import LogsViewModal from "../../components/Common/Modals/logViewModal"
import { translations } from "../../utils/Translation/staticTranslation"

const BulkUpload = () => {
  const { storeId } = useParams()
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [fileObj, setFileObj] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingFiles, setLoadingFiles] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [uploadFiles, setUploadedFiles] = useState([])

  const lang = localStorage.getItem("language") || "ar"
  const product = translations[lang]?.productPage
  const bulkupload = translations[lang]?.productPage?.bulk_upload_page
  const common_btn = translations[lang]?.common_btn
  const modal = translations[lang]?.modals
  const { common_error_msg } = translations[lang]

  // Delete confirmation modal state
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [fileToDelete, setFileToDelete] = useState(null)

  // Logs view modal state
  const [logsModalVisible, setLogsModalVisible] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)

  const onFinish = async (values) => {
    if (!fileObj) {
      message.error(common_error_msg?.please_upload_a_file)
      return
    }

    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("file", fileObj)
      formData.append("store", storeId)

      const response = await Product.addProduct(formData)
      if (response.status === 202) {
        form.resetFields()
        handleFetchUploadedFiles()
        setFileObj(null)
        message.success(common_error_msg?.file_uploaded_being_processed, 6)
      }
    } catch (error) {
      message.error(
        lang === "en"
          ? error.response.data.error
          : error.response.data.errorArabic
      )
    } finally {
      setLoading(false)
    }
  }

  const handleFetchUploadedFiles = async () => {
    setLoadingFiles(true)

    try {
      const response = await Product.getUploadedFiles(storeId)
      if (response.status === 200) {
        setUploadedFiles(response.data.data)
      }
    } catch (error) {
      console.error("Error:", error)
      message.error(common_error_msg?.failed_to_fetch_uploaded_files)
    } finally {
      setLoadingFiles(false)
    }
  }

  useEffect(() => {
    handleFetchUploadedFiles()
  }, [])

  const handleCancel = () => {
    navigate("/products")
  }

  // Show delete confirmation modal
  const showDeleteConfirmation = (file) => {
    setFileToDelete(file)
    setDeleteModalVisible(true)
  }

  // Handle delete confirmation
  const handleDeleteConfirm = () => {
    handleDeleteuploadedFile(fileToDelete)
    setDeleteModalVisible(false)
  }

  // Handle delete cancellation
  const handleDeleteCancel = () => {
    setDeleteModalVisible(false)
    setFileToDelete(null)
  }

  // Show logs view modal
  const handleViewLogs = (file) => {
    setSelectedFile(file)
    setLogsModalVisible(true)
  }

  // Handle logs modal close
  const handleLogsModalClose = () => {
    setLogsModalVisible(false)
    setSelectedFile(null)
  }

  const handleDeleteuploadedFile = async (fileId) => {
    setDeleteLoading(true)
    const formData = new FormData()
    if (fileId?.id) formData.append("file", fileId.id)

    try {
      const response = await Product.deleteUploadedFile(formData)
      if (response.status === 200) {
        setUploadedFiles((prev) => prev.filter((file) => file.id !== fileId.id))
        message.success(
          bulkupload?.file_deleted_successfully || "File deleted successfully"
        )
      }
    } catch (error) {
      console.error("Error:", error)
      message.error("Failed to delete file")
    } finally {
      setDeleteLoading(false)
    }
  }

  return (
    <>
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          <div className="d-flex mb-22">
            <div>
              <img
                src="/icons/backpagearrow.svg"
                style={{
                  transform: lang === "ar" ? "rotateY(180deg)" : "none",
                }}
                alt=""
                className={`${lang === "ar" ? "ml-10" : "mr-10"}`}
                onClick={() => navigate("/products")}
              />
            </div>
            <div>
              <h1 className="text-141414 text-20">{product?.bulk_upload} </h1>
              <p className="text-504943 text-13 mb-0">
                {product.products}{" "}
                <span className="text-85849D">/ {product?.bulk_upload}</span>
              </p>
            </div>
          </div>
          <Form form={form} onFinish={onFinish}>
            <div>
              <div className="content-fit-container">
                <div className="d-flex justify-content-between mb-28">
                  <div>
                    <p className="text-16 font-700 text-141414">
                      {bulkupload?.upload_file}
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <p
                      className={`text-12 font-400 text-141414 mb-0 ${
                        lang === "ar" ? "ml-10" : "mr-10"
                      }`}
                    >
                      {bulkupload?.no_template_text}
                    </p>
                    <button
                      className="btn-bulk-upload"
                      type="button"
                      onClick={() => {
                        const link = document.createElement("a")
                        link.href =
                          "https://mesaky-products-backup.s3.ap-south-1.amazonaws.com/products_template1.xlsx"
                        link.setAttribute("download", "products_template.xlsx")
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                      }}
                    >
                      {bulkupload?.download_template}
                    </button>
                  </div>
                </div>
                <div className="mb-30">
                  <Form.Item
                    name="logo"
                    rules={[
                      {
                        required: true,
                        message: bulkupload?.required_file_validation,
                      },
                    ]}
                  >
                    <CustomUpload
                      onChange={(file) => setFileObj(file)}
                      form={form}
                      name="logo"
                      acceptedFormats={[".xls", ".xlsx"]}
                      maxSizeMB={5}
                      uploadText={bulkupload?.upload_size}
                      bulkUpload={false}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-12">
                <button
                  className={`cancel-btn ${lang === "ar" ? "ml-10" : "mr-10"}`}
                  type="button"
                  onClick={handleCancel}
                >
                  {common_btn?.cancel_btn}
                </button>
                <button
                  className={`Add-btn bg-504943 ${loading && "not-allowed"}`}
                  disabled={loading}
                  type="submit"
                >
                  {common_btn?.upload}
                </button>
              </div>
            </div>
          </Form>

          <div className="content-fit-container mt-18">
            <p className="text-16 font-700 text-141414">
              {bulkupload?.table?.previous_upload}
            </p>

            {loadingFiles ? (
              <>
                <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                  <Spin size="large" />
                </div>
              </>
            ) : (
              <>
                <Table
                  columns={BulkUploadColumns}
                  data={uploadFiles}
                  actions={BulkUploadActions(
                    showDeleteConfirmation,
                    deleteLoading,
                    handleViewLogs
                  )}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        visible={deleteModalVisible}
        onCancel={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title={modal?.confirm_delete_text}
        content={
          <>
            {modal?.description_1} ${fileToDelete?.file_name || "this file"}?{" "}
            {modal?.description_2}
          </>
        }
      />

      {/* Logs View Modal */}
      <LogsViewModal
        visible={logsModalVisible}
        onCancel={handleLogsModalClose}
        file={selectedFile}
      />
    </>
  )
}

export default BulkUpload
